import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Log from "../images/login_banner.webp";
import "../customCss/Login.css";
import Logo from "../images/wevillage_logo_main.webp";
import AuthService from "../services/auth.service";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const auth = AuthService.getCurrentUserTokken();
    if (auth) {
      navigate("/dashboard");
    }
  }, [navigate]);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const form = useRef();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Email & Password are required!");
      return;
    }
    setLoading(true);
    AuthService.login(username, password).then(
      () => {
        toast.success("Login Successful!!");
        navigate("/dashboard");
      },
      (error) => {
        const resMessage = error?.response?.data?.message || "Unable to Login";
        setLoading(false);
        toast.error(resMessage);
      }
    );
  };
  return (
    <>
      <section className="login_sec">
        <div className="login_nav">
          <img src={Logo} alt="" className="site_logo" />
        </div>
        <div className="login_flex">
          <div className="loginL">
            <img src={Log} alt="" />
          </div>
          <div className="loginR">
            <form ref={form} onSubmit={handleLogin}>
              <div className="login_formSec">
                <h1>Login</h1>
                <div className="form-floating mb-4">
                  <input
                    type="email"
                    className="form-control"
                    id="floatingInput"
                    placeholder=""
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <label for="floatingInput">Email address</label>
                </div>
                <div className="form-floating mb-4">
                  <input
                    type={showPass ? "text" : "password"}
                    className="form-control"
                    id="floatingPassword"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <label for="floatingPassword">Password</label>
                  <i
                    className={`fas passEye ${
                      showPass ? "fa-eye-slash" : "fa-eye"
                    }`}
                    onClick={() => setShowPass(!showPass)}
                  />
                </div>
                <div className="form_field">
                  <button
                    className="main_button"
                    disabled={loading}
                    onClick={handleLogin}
                  >
                    {loading ? (
                      <i
                        className="fa fa-spinner fa-spin font-light"
                        style={{ fontSize: "16px" }}
                      />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
